// @generated by protobuf-ts 2.8.1 with parameter generate_dependencies,long_type_number,ts_nocheck,optimize_code_size
// @generated from protobuf file "c1/api/profiletype/v1/profiletype.proto" (package "c1.api.profiletype.v1", syntax proto3)
// tslint:disable
// @ts-nocheck
import { ServiceType } from "@protobuf-ts/runtime-rpc";
import { MessageType } from "@protobuf-ts/runtime";
import { FieldMask } from "../../../../google/protobuf/field_mask";
/**
 * ProfileType represents a type of profile in the system
 *
 * @generated from protobuf message c1.api.profiletype.v1.ProfileType
 */
export interface ProfileType {
    /**
     * @generated from protobuf field: string id = 1;
     */
    id: string;
    /**
     * @generated from protobuf field: string name = 2;
     */
    name: string;
    /**
     * @generated from protobuf field: string description = 3;
     */
    description: string;
    /**
     * @generated from protobuf field: string icon_url = 4;
     */
    iconUrl: string;
    /**
     * @generated from protobuf field: uint32 priority = 5;
     */
    priority: number;
    /**
     * icon sizes
     *
     * @generated from protobuf field: repeated int32 sizes = 6;
     */
    sizes: number[];
    /**
     * Add this field to allow users to reference profile type in cel expressions
     *
     * @generated from protobuf field: string slug = 7;
     */
    slug: string;
    /**
     * Whether to display this profile type to users in profile page. Defaults to false if not set
     *
     * @generated from protobuf field: bool display_to_user = 8;
     */
    displayToUser: boolean;
}
/**
 * ProfileTypeRef represents a reference to a ProfileType
 *
 * @generated from protobuf message c1.api.profiletype.v1.ProfileTypeRef
 */
export interface ProfileTypeRef {
    /**
     * @generated from protobuf field: string id = 1;
     */
    id: string;
}
/**
 * ProfileTypeUserAttributeMappingBinding represents a binding between a profile type and user attribute mapping
 *
 * @generated from protobuf message c1.api.profiletype.v1.ProfileTypeUserAttributeMappingBinding
 */
export interface ProfileTypeUserAttributeMappingBinding {
    /**
     * @generated from protobuf field: string profile_type_id = 1;
     */
    profileTypeId: string;
    /**
     * @generated from protobuf field: string user_attribute_mapping_id = 2;
     */
    userAttributeMappingId: string;
}
// Request messages for ProfileTypeService

/**
 * @generated from protobuf message c1.api.profiletype.v1.ProfileTypeServiceGetRequest
 */
export interface ProfileTypeServiceGetRequest {
    /**
     * @generated from protobuf field: string id = 1;
     */
    id: string;
}
/**
 * @generated from protobuf message c1.api.profiletype.v1.ProfileTypeServiceGetResponse
 */
export interface ProfileTypeServiceGetResponse {
    /**
     * @generated from protobuf field: c1.api.profiletype.v1.ProfileType profile_type = 1;
     */
    profileType?: ProfileType;
}
/**
 * @generated from protobuf message c1.api.profiletype.v1.ProfileTypeServiceCreateRequest
 */
export interface ProfileTypeServiceCreateRequest {
    /**
     * @generated from protobuf field: string name = 1;
     */
    name: string;
    /**
     * @generated from protobuf field: string description = 2;
     */
    description: string;
    /**
     * @generated from protobuf field: bytes icon_data = 3;
     */
    iconData: Uint8Array;
    /**
     * @generated from protobuf field: string slug = 4;
     */
    slug: string;
    /**
     * @generated from protobuf field: bool display_to_user = 5;
     */
    displayToUser: boolean;
}
/**
 * @generated from protobuf message c1.api.profiletype.v1.ProfileTypeServiceCreateResponse
 */
export interface ProfileTypeServiceCreateResponse {
    /**
     * @generated from protobuf field: c1.api.profiletype.v1.ProfileType profile_type = 1;
     */
    profileType?: ProfileType;
}
/**
 * @generated from protobuf message c1.api.profiletype.v1.ProfileTypeServiceUpdateRequest
 */
export interface ProfileTypeServiceUpdateRequest {
    /**
     * @generated from protobuf field: c1.api.profiletype.v1.ProfileType profile_type = 1;
     */
    profileType?: ProfileType;
    /**
     * @generated from protobuf field: google.protobuf.FieldMask update_mask = 2;
     */
    updateMask?: FieldMask;
    /**
     * @generated from protobuf field: bytes icon_data = 3;
     */
    iconData: Uint8Array;
}
/**
 * @generated from protobuf message c1.api.profiletype.v1.ProfileTypeServiceUpdateResponse
 */
export interface ProfileTypeServiceUpdateResponse {
    /**
     * @generated from protobuf field: c1.api.profiletype.v1.ProfileType profile_type = 1;
     */
    profileType?: ProfileType;
}
/**
 * @generated from protobuf message c1.api.profiletype.v1.ProfileTypeServiceDeleteRequest
 */
export interface ProfileTypeServiceDeleteRequest {
    /**
     * @generated from protobuf field: string id = 1;
     */
    id: string;
}
/**
 * @generated from protobuf message c1.api.profiletype.v1.ProfileTypeServiceDeleteResponse
 */
export interface ProfileTypeServiceDeleteResponse {
}
/**
 * @generated from protobuf message c1.api.profiletype.v1.SetProfileTypeIconRequest
 */
export interface SetProfileTypeIconRequest {
    /**
     * @generated from protobuf field: string profile_type_id = 1;
     */
    profileTypeId: string;
    /**
     * @generated from protobuf field: bytes data = 2;
     */
    data: Uint8Array;
}
/**
 * @generated from protobuf message c1.api.profiletype.v1.SetProfileTypeIconResponse
 */
export interface SetProfileTypeIconResponse {
}
// Request messages for ProfileTypeSearchService

/**
 * @generated from protobuf message c1.api.profiletype.v1.ProfileTypeSearchRequest
 */
export interface ProfileTypeSearchRequest {
    /**
     * @generated from protobuf field: string query = 1;
     */
    query: string;
    /**
     * @generated from protobuf field: int32 page_size = 2;
     */
    pageSize: number;
    /**
     * @generated from protobuf field: string page_token = 3;
     */
    pageToken: string;
    /**
     * @generated from protobuf field: repeated c1.api.profiletype.v1.ProfileTypeRef refs = 4;
     */
    refs: ProfileTypeRef[];
}
/**
 * @generated from protobuf message c1.api.profiletype.v1.ProfileTypeSearchResponse
 */
export interface ProfileTypeSearchResponse {
    /**
     * @generated from protobuf field: repeated c1.api.profiletype.v1.ProfileType list = 1;
     */
    list: ProfileType[];
    /**
     * @generated from protobuf field: string next_page_token = 2;
     */
    nextPageToken: string;
}
/**
 * @generated from protobuf message c1.api.profiletype.v1.ProfileTypeSearchByAttributeMappingIdRequest
 */
export interface ProfileTypeSearchByAttributeMappingIdRequest {
    /**
     * @generated from protobuf field: string attribute_mapping_id = 1;
     */
    attributeMappingId: string;
    /**
     * @generated from protobuf field: int32 page_size = 2;
     */
    pageSize: number;
    /**
     * @generated from protobuf field: string page_token = 3;
     */
    pageToken: string;
}
/**
 * @generated from protobuf message c1.api.profiletype.v1.ProfileTypeSearchByAttributeMappingIdResponse
 */
export interface ProfileTypeSearchByAttributeMappingIdResponse {
    /**
     * @generated from protobuf field: repeated c1.api.profiletype.v1.ProfileType list = 1;
     */
    list: ProfileType[];
    /**
     * @generated from protobuf field: string next_page_token = 2;
     */
    nextPageToken: string;
}
/**
 * @generated from protobuf message c1.api.profiletype.v1.ProfileTypeUserAttributeMappingBindingServiceListRequest
 */
export interface ProfileTypeUserAttributeMappingBindingServiceListRequest {
    /**
     * @generated from protobuf field: string profile_type_id = 1;
     */
    profileTypeId: string;
    /**
     * @generated from protobuf field: int32 page_size = 2;
     */
    pageSize: number;
    /**
     * @generated from protobuf field: string page_token = 3;
     */
    pageToken: string;
}
/**
 * @generated from protobuf message c1.api.profiletype.v1.ProfileTypeUserAttributeMappingBindingServiceListResponse
 */
export interface ProfileTypeUserAttributeMappingBindingServiceListResponse {
    /**
     * @generated from protobuf field: repeated c1.api.profiletype.v1.ProfileTypeUserAttributeMappingBinding list = 1;
     */
    list: ProfileTypeUserAttributeMappingBinding[];
    /**
     * @generated from protobuf field: string next_page_token = 2;
     */
    nextPageToken: string;
}
/**
 * @generated from protobuf message c1.api.profiletype.v1.ProfileTypeUserAttributeMappingBindingServiceUpdateRequest
 */
export interface ProfileTypeUserAttributeMappingBindingServiceUpdateRequest {
    /**
     * @generated from protobuf field: string profile_type_id = 1;
     */
    profileTypeId: string;
    /**
     * @generated from protobuf field: repeated c1.api.profiletype.v1.ProfileTypeUserAttributeMappingBinding bindings = 2;
     */
    bindings: ProfileTypeUserAttributeMappingBinding[];
}
/**
 * @generated from protobuf message c1.api.profiletype.v1.ProfileTypeUserAttributeMappingBindingServiceUpdateResponse
 */
export interface ProfileTypeUserAttributeMappingBindingServiceUpdateResponse {
    /**
     * @generated from protobuf field: repeated c1.api.profiletype.v1.ProfileTypeUserAttributeMappingBinding bindings = 1;
     */
    bindings: ProfileTypeUserAttributeMappingBinding[];
}
/**
 * @generated from protobuf message c1.api.profiletype.v1.ProfileTypeUserAttributeMappingBindingServiceCountByUserAttributeMappingIdRequest
 */
export interface ProfileTypeUserAttributeMappingBindingServiceCountByUserAttributeMappingIdRequest {
    /**
     * @generated from protobuf field: string user_attribute_mapping_id = 1;
     */
    userAttributeMappingId: string;
}
/**
 * @generated from protobuf message c1.api.profiletype.v1.ProfileTypeUserAttributeMappingBindingServiceCountByUserAttributeMappingIdResponse
 */
export interface ProfileTypeUserAttributeMappingBindingServiceCountByUserAttributeMappingIdResponse {
    /**
     * @generated from protobuf field: int32 count = 1;
     */
    count: number;
}
// @generated message type with reflection information, may provide speed optimized methods
class ProfileType$Type extends MessageType<ProfileType> {
    constructor() {
        super("c1.api.profiletype.v1.ProfileType", [
            { no: 1, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 2, name: "name", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minLen: "1", maxLen: "255" } } } },
            { no: 3, name: "description", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { maxLen: "1000" } } } },
            { no: 4, name: "icon_url", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { maxLen: "2048" } } } },
            { no: 5, name: "priority", kind: "scalar", T: 13 /*ScalarType.UINT32*/ },
            { no: 6, name: "sizes", kind: "scalar", repeat: 1 /*RepeatType.PACKED*/, T: 5 /*ScalarType.INT32*/ },
            { no: 7, name: "slug", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minLen: "0", maxLen: "255" } } } },
            { no: 8, name: "display_to_user", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.profiletype.v1.ProfileType
 */
export const ProfileType = new ProfileType$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ProfileTypeRef$Type extends MessageType<ProfileTypeRef> {
    constructor() {
        super("c1.api.profiletype.v1.ProfileTypeRef", [
            { no: 1, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.profiletype.v1.ProfileTypeRef
 */
export const ProfileTypeRef = new ProfileTypeRef$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ProfileTypeUserAttributeMappingBinding$Type extends MessageType<ProfileTypeUserAttributeMappingBinding> {
    constructor() {
        super("c1.api.profiletype.v1.ProfileTypeUserAttributeMappingBinding", [
            { no: 1, name: "profile_type_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 2, name: "user_attribute_mapping_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.profiletype.v1.ProfileTypeUserAttributeMappingBinding
 */
export const ProfileTypeUserAttributeMappingBinding = new ProfileTypeUserAttributeMappingBinding$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ProfileTypeServiceGetRequest$Type extends MessageType<ProfileTypeServiceGetRequest> {
    constructor() {
        super("c1.api.profiletype.v1.ProfileTypeServiceGetRequest", [
            { no: 1, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.profiletype.v1.ProfileTypeServiceGetRequest
 */
export const ProfileTypeServiceGetRequest = new ProfileTypeServiceGetRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ProfileTypeServiceGetResponse$Type extends MessageType<ProfileTypeServiceGetResponse> {
    constructor() {
        super("c1.api.profiletype.v1.ProfileTypeServiceGetResponse", [
            { no: 1, name: "profile_type", kind: "message", T: () => ProfileType }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.profiletype.v1.ProfileTypeServiceGetResponse
 */
export const ProfileTypeServiceGetResponse = new ProfileTypeServiceGetResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ProfileTypeServiceCreateRequest$Type extends MessageType<ProfileTypeServiceCreateRequest> {
    constructor() {
        super("c1.api.profiletype.v1.ProfileTypeServiceCreateRequest", [
            { no: 1, name: "name", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minLen: "1", maxLen: "255" } }, "apigw.v1.field": { fieldOptions: [{ requiredSpec: true }] } } },
            { no: 2, name: "description", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { maxLen: "1000" } } } },
            { no: 3, name: "icon_data", kind: "scalar", T: 12 /*ScalarType.BYTES*/, options: { "validate.rules": { bytes: { minLen: "0", maxLen: "1000000" } } } },
            { no: 4, name: "slug", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minLen: "0", maxLen: "255" } }, "apigw.v1.field": { fieldOptions: [{ requiredSpec: true }] } } },
            { no: 5, name: "display_to_user", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.profiletype.v1.ProfileTypeServiceCreateRequest
 */
export const ProfileTypeServiceCreateRequest = new ProfileTypeServiceCreateRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ProfileTypeServiceCreateResponse$Type extends MessageType<ProfileTypeServiceCreateResponse> {
    constructor() {
        super("c1.api.profiletype.v1.ProfileTypeServiceCreateResponse", [
            { no: 1, name: "profile_type", kind: "message", T: () => ProfileType }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.profiletype.v1.ProfileTypeServiceCreateResponse
 */
export const ProfileTypeServiceCreateResponse = new ProfileTypeServiceCreateResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ProfileTypeServiceUpdateRequest$Type extends MessageType<ProfileTypeServiceUpdateRequest> {
    constructor() {
        super("c1.api.profiletype.v1.ProfileTypeServiceUpdateRequest", [
            { no: 1, name: "profile_type", kind: "message", T: () => ProfileType },
            { no: 2, name: "update_mask", kind: "message", T: () => FieldMask },
            { no: 3, name: "icon_data", kind: "scalar", T: 12 /*ScalarType.BYTES*/, options: { "validate.rules": { bytes: { minLen: "0", maxLen: "1000000" } } } }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.profiletype.v1.ProfileTypeServiceUpdateRequest
 */
export const ProfileTypeServiceUpdateRequest = new ProfileTypeServiceUpdateRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ProfileTypeServiceUpdateResponse$Type extends MessageType<ProfileTypeServiceUpdateResponse> {
    constructor() {
        super("c1.api.profiletype.v1.ProfileTypeServiceUpdateResponse", [
            { no: 1, name: "profile_type", kind: "message", T: () => ProfileType }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.profiletype.v1.ProfileTypeServiceUpdateResponse
 */
export const ProfileTypeServiceUpdateResponse = new ProfileTypeServiceUpdateResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ProfileTypeServiceDeleteRequest$Type extends MessageType<ProfileTypeServiceDeleteRequest> {
    constructor() {
        super("c1.api.profiletype.v1.ProfileTypeServiceDeleteRequest", [
            { no: 1, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.profiletype.v1.ProfileTypeServiceDeleteRequest
 */
export const ProfileTypeServiceDeleteRequest = new ProfileTypeServiceDeleteRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ProfileTypeServiceDeleteResponse$Type extends MessageType<ProfileTypeServiceDeleteResponse> {
    constructor() {
        super("c1.api.profiletype.v1.ProfileTypeServiceDeleteResponse", []);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.profiletype.v1.ProfileTypeServiceDeleteResponse
 */
export const ProfileTypeServiceDeleteResponse = new ProfileTypeServiceDeleteResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SetProfileTypeIconRequest$Type extends MessageType<SetProfileTypeIconRequest> {
    constructor() {
        super("c1.api.profiletype.v1.SetProfileTypeIconRequest", [
            { no: 1, name: "profile_type_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 2, name: "data", kind: "scalar", T: 12 /*ScalarType.BYTES*/, options: { "validate.rules": { bytes: { minLen: "0", maxLen: "1000000" } } } }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.profiletype.v1.SetProfileTypeIconRequest
 */
export const SetProfileTypeIconRequest = new SetProfileTypeIconRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SetProfileTypeIconResponse$Type extends MessageType<SetProfileTypeIconResponse> {
    constructor() {
        super("c1.api.profiletype.v1.SetProfileTypeIconResponse", []);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.profiletype.v1.SetProfileTypeIconResponse
 */
export const SetProfileTypeIconResponse = new SetProfileTypeIconResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ProfileTypeSearchRequest$Type extends MessageType<ProfileTypeSearchRequest> {
    constructor() {
        super("c1.api.profiletype.v1.ProfileTypeSearchRequest", [
            { no: 1, name: "query", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "0", maxBytes: "1024" } } } },
            { no: 2, name: "page_size", kind: "scalar", T: 5 /*ScalarType.INT32*/, options: { "validate.rules": { int32: { lte: 100, gte: 0 } } } },
            { no: 3, name: "page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "0", maxBytes: "1024" } } } },
            { no: 4, name: "refs", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => ProfileTypeRef }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.profiletype.v1.ProfileTypeSearchRequest
 */
export const ProfileTypeSearchRequest = new ProfileTypeSearchRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ProfileTypeSearchResponse$Type extends MessageType<ProfileTypeSearchResponse> {
    constructor() {
        super("c1.api.profiletype.v1.ProfileTypeSearchResponse", [
            { no: 1, name: "list", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => ProfileType },
            { no: 2, name: "next_page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.profiletype.v1.ProfileTypeSearchResponse
 */
export const ProfileTypeSearchResponse = new ProfileTypeSearchResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ProfileTypeSearchByAttributeMappingIdRequest$Type extends MessageType<ProfileTypeSearchByAttributeMappingIdRequest> {
    constructor() {
        super("c1.api.profiletype.v1.ProfileTypeSearchByAttributeMappingIdRequest", [
            { no: 1, name: "attribute_mapping_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 2, name: "page_size", kind: "scalar", T: 5 /*ScalarType.INT32*/, options: { "validate.rules": { int32: { lte: 100, gte: 0 } } } },
            { no: 3, name: "page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "0", maxBytes: "1024" } } } }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.profiletype.v1.ProfileTypeSearchByAttributeMappingIdRequest
 */
export const ProfileTypeSearchByAttributeMappingIdRequest = new ProfileTypeSearchByAttributeMappingIdRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ProfileTypeSearchByAttributeMappingIdResponse$Type extends MessageType<ProfileTypeSearchByAttributeMappingIdResponse> {
    constructor() {
        super("c1.api.profiletype.v1.ProfileTypeSearchByAttributeMappingIdResponse", [
            { no: 1, name: "list", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => ProfileType },
            { no: 2, name: "next_page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.profiletype.v1.ProfileTypeSearchByAttributeMappingIdResponse
 */
export const ProfileTypeSearchByAttributeMappingIdResponse = new ProfileTypeSearchByAttributeMappingIdResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ProfileTypeUserAttributeMappingBindingServiceListRequest$Type extends MessageType<ProfileTypeUserAttributeMappingBindingServiceListRequest> {
    constructor() {
        super("c1.api.profiletype.v1.ProfileTypeUserAttributeMappingBindingServiceListRequest", [
            { no: 1, name: "profile_type_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 2, name: "page_size", kind: "scalar", T: 5 /*ScalarType.INT32*/, options: { "validate.rules": { int32: { lte: 100, gte: 0 } } } },
            { no: 3, name: "page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "0", maxBytes: "1024" } } } }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.profiletype.v1.ProfileTypeUserAttributeMappingBindingServiceListRequest
 */
export const ProfileTypeUserAttributeMappingBindingServiceListRequest = new ProfileTypeUserAttributeMappingBindingServiceListRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ProfileTypeUserAttributeMappingBindingServiceListResponse$Type extends MessageType<ProfileTypeUserAttributeMappingBindingServiceListResponse> {
    constructor() {
        super("c1.api.profiletype.v1.ProfileTypeUserAttributeMappingBindingServiceListResponse", [
            { no: 1, name: "list", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => ProfileTypeUserAttributeMappingBinding },
            { no: 2, name: "next_page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.profiletype.v1.ProfileTypeUserAttributeMappingBindingServiceListResponse
 */
export const ProfileTypeUserAttributeMappingBindingServiceListResponse = new ProfileTypeUserAttributeMappingBindingServiceListResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ProfileTypeUserAttributeMappingBindingServiceUpdateRequest$Type extends MessageType<ProfileTypeUserAttributeMappingBindingServiceUpdateRequest> {
    constructor() {
        super("c1.api.profiletype.v1.ProfileTypeUserAttributeMappingBindingServiceUpdateRequest", [
            { no: 1, name: "profile_type_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 2, name: "bindings", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => ProfileTypeUserAttributeMappingBinding }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.profiletype.v1.ProfileTypeUserAttributeMappingBindingServiceUpdateRequest
 */
export const ProfileTypeUserAttributeMappingBindingServiceUpdateRequest = new ProfileTypeUserAttributeMappingBindingServiceUpdateRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ProfileTypeUserAttributeMappingBindingServiceUpdateResponse$Type extends MessageType<ProfileTypeUserAttributeMappingBindingServiceUpdateResponse> {
    constructor() {
        super("c1.api.profiletype.v1.ProfileTypeUserAttributeMappingBindingServiceUpdateResponse", [
            { no: 1, name: "bindings", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => ProfileTypeUserAttributeMappingBinding }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.profiletype.v1.ProfileTypeUserAttributeMappingBindingServiceUpdateResponse
 */
export const ProfileTypeUserAttributeMappingBindingServiceUpdateResponse = new ProfileTypeUserAttributeMappingBindingServiceUpdateResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ProfileTypeUserAttributeMappingBindingServiceCountByUserAttributeMappingIdRequest$Type extends MessageType<ProfileTypeUserAttributeMappingBindingServiceCountByUserAttributeMappingIdRequest> {
    constructor() {
        super("c1.api.profiletype.v1.ProfileTypeUserAttributeMappingBindingServiceCountByUserAttributeMappingIdRequest", [
            { no: 1, name: "user_attribute_mapping_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.profiletype.v1.ProfileTypeUserAttributeMappingBindingServiceCountByUserAttributeMappingIdRequest
 */
export const ProfileTypeUserAttributeMappingBindingServiceCountByUserAttributeMappingIdRequest = new ProfileTypeUserAttributeMappingBindingServiceCountByUserAttributeMappingIdRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ProfileTypeUserAttributeMappingBindingServiceCountByUserAttributeMappingIdResponse$Type extends MessageType<ProfileTypeUserAttributeMappingBindingServiceCountByUserAttributeMappingIdResponse> {
    constructor() {
        super("c1.api.profiletype.v1.ProfileTypeUserAttributeMappingBindingServiceCountByUserAttributeMappingIdResponse", [
            { no: 1, name: "count", kind: "scalar", T: 5 /*ScalarType.INT32*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.profiletype.v1.ProfileTypeUserAttributeMappingBindingServiceCountByUserAttributeMappingIdResponse
 */
export const ProfileTypeUserAttributeMappingBindingServiceCountByUserAttributeMappingIdResponse = new ProfileTypeUserAttributeMappingBindingServiceCountByUserAttributeMappingIdResponse$Type();
/**
 * @generated ServiceType for protobuf service c1.api.profiletype.v1.ProfileTypeService
 */
export const ProfileTypeService = new ServiceType("c1.api.profiletype.v1.ProfileTypeService", [
    { name: "Get", options: { "authz.method": { role: "VIEWER" } }, I: ProfileTypeServiceGetRequest, O: ProfileTypeServiceGetResponse },
    { name: "Create", options: { "authz.method": { role: "EDITOR" } }, I: ProfileTypeServiceCreateRequest, O: ProfileTypeServiceCreateResponse },
    { name: "Update", options: { "authz.method": { role: "EDITOR" } }, I: ProfileTypeServiceUpdateRequest, O: ProfileTypeServiceUpdateResponse },
    { name: "Delete", options: { "authz.method": { role: "EDITOR" } }, I: ProfileTypeServiceDeleteRequest, O: ProfileTypeServiceDeleteResponse },
    { name: "SetProfileTypeIcon", options: { "authz.method": { role: "EDITOR" } }, I: SetProfileTypeIconRequest, O: SetProfileTypeIconResponse }
]);
/**
 * @generated ServiceType for protobuf service c1.api.profiletype.v1.ProfileTypeSearchService
 */
export const ProfileTypeSearchService = new ServiceType("c1.api.profiletype.v1.ProfileTypeSearchService", [
    { name: "Search", options: { "authz.method": { role: "VIEWER" } }, I: ProfileTypeSearchRequest, O: ProfileTypeSearchResponse },
    { name: "SearchByAttributeMappingId", options: { "authz.method": { role: "VIEWER" } }, I: ProfileTypeSearchByAttributeMappingIdRequest, O: ProfileTypeSearchByAttributeMappingIdResponse }
]);
/**
 * @generated ServiceType for protobuf service c1.api.profiletype.v1.ProfileTypeUserAttributeMappingBindingService
 */
export const ProfileTypeUserAttributeMappingBindingService = new ServiceType("c1.api.profiletype.v1.ProfileTypeUserAttributeMappingBindingService", [
    { name: "List", options: { "authz.method": { role: "VIEWER" } }, I: ProfileTypeUserAttributeMappingBindingServiceListRequest, O: ProfileTypeUserAttributeMappingBindingServiceListResponse },
    { name: "Update", options: { "authz.method": { role: "EDITOR" } }, I: ProfileTypeUserAttributeMappingBindingServiceUpdateRequest, O: ProfileTypeUserAttributeMappingBindingServiceUpdateResponse },
    { name: "CountByUserAttributeMappingId", options: { "authz.method": { role: "VIEWER" } }, I: ProfileTypeUserAttributeMappingBindingServiceCountByUserAttributeMappingIdRequest, O: ProfileTypeUserAttributeMappingBindingServiceCountByUserAttributeMappingIdResponse }
]);
